import { twMerge } from '@florencelabs/fabric-styles';
import { composeRenderProps } from 'react-aria-components';

export const composeTailwindRenderProps = <T>(
  className: string | ((v: T) => string) | undefined,
  tw: string,
): string | ((v: T) => string) => {
  return composeRenderProps(className, (cl) => twMerge(tw, cl));
};
